/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Header_OutInputs */

const en_ccsl_export_header_out = /** @type {(inputs: Ccsl_Export_Header_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OUT`)
};

const fr_ccsl_export_header_out = /** @type {(inputs: Ccsl_Export_Header_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OUT`)
};

const de_ccsl_export_header_out = /** @type {(inputs: Ccsl_Export_Header_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AUS`)
};

const it_ccsl_export_header_out = /** @type {(inputs: Ccsl_Export_Header_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FUORI`)
};

const ru_ccsl_export_header_out = /** @type {(inputs: Ccsl_Export_Header_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ВНЕ`)
};

const es_ccsl_export_header_out = /** @type {(inputs: Ccsl_Export_Header_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AFUERA`)
};

const zh_cn2_ccsl_export_header_out = /** @type {(inputs: Ccsl_Export_Header_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出去`)
};

const ja_ccsl_export_header_out = /** @type {(inputs: Ccsl_Export_Header_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`外`)
};

const hi_ccsl_export_header_out = /** @type {(inputs: Ccsl_Export_Header_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बाहर`)
};

const pt_pt2_ccsl_export_header_out = /** @type {(inputs: Ccsl_Export_Header_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FORA`)
};

/**
* | output |
* | --- |
* | "OUT" |
*
* @param {Ccsl_Export_Header_OutInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_header_out = /** @type {((inputs?: Ccsl_Export_Header_OutInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Header_OutInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ccsl_export_header_out(inputs)
	if (locale === "de") return de_ccsl_export_header_out(inputs)
	if (locale === "it") return it_ccsl_export_header_out(inputs)
	if (locale === "ru") return ru_ccsl_export_header_out(inputs)
	if (locale === "es") return es_ccsl_export_header_out(inputs)
	if (locale === "zh-CN") return zh_cn2_ccsl_export_header_out(inputs)
	if (locale === "ja") return ja_ccsl_export_header_out(inputs)
	if (locale === "hi") return hi_ccsl_export_header_out(inputs)
	if (locale === "pt-PT") return pt_pt2_ccsl_export_header_out(inputs)
	return en_ccsl_export_header_out(inputs)
});